export default {
    verifyRole(role) {
        return !role || localStorage.getItem("roles").includes(role);
    },
    logout() {
        localStorage.removeItem("token");
        localStorage.removeItem("roles");
        localStorage.removeItem("name");
        localStorage.removeItem("email");
        localStorage.removeItem("password");
    },
    login(req, res) {
        localStorage.setItem("roles", res.roles);
        localStorage.setItem("token", res.token);
        localStorage.setItem("name", res.name);
        localStorage.setItem("email", req.email);
        localStorage.setItem("password", req.password);
    },
    getToken() {
        return localStorage.getItem("token");
    },
    getName() {
        return localStorage.getItem("name");
    },
    getEmail() {
        return localStorage.getItem("email");
    },
    getPassword() {
        return localStorage.getItem("password");
    },
    isAuth() {
        return localStorage.getItem("token") ? true : false;
    }
};